import { configureStore } from "@reduxjs/toolkit";
import dashboardReducer from "./dashboardSlice";
import { reduxDevToolsConfig } from "./devToolsConfig";

export const store = configureStore({
  reducer: {
    dashboard: dashboardReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ["persist/PERSIST"],
      },
    }),
  // Use optimized DevTools configuration only in development
  devTools: import.meta.env.DEV ? (reduxDevToolsConfig as Parameters<typeof configureStore>[0]['devTools']) : false,
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
